import LocationEditSVG from 'assets/lucide-js/locationEdit.svg?react'
import { HoverableToggle } from 'components/HoverableToggle'
import { PermissionsGate } from 'features/permissions'
import { StyledMapToggle } from 'features/siteMap/popupMenus/modebarToggles/StyledMapToggle'
import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'
import {
  PERMISSION_CANTILEVER_CORE_ADMIN,
  PERMISSION_CANTILEVER_CORE_EDIT,
} from 'types'

const Container = styled.div`
  position: absolute;
  top: 2%;
  left: 2%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

interface MapboxModebarProps {
  isInEditSiteBoundsMode: boolean
  setIsInEditSiteBoundsMode: Dispatch<SetStateAction<boolean>>
}
export const MapboxModebar: FC<MapboxModebarProps> = (props) => {
  return (
    <Container>
      <PermissionsGate
        requires={[
          PERMISSION_CANTILEVER_CORE_ADMIN,
          PERMISSION_CANTILEVER_CORE_EDIT,
        ]}>
        <HoverableToggle
          defaultPressed={props.isInEditSiteBoundsMode}
          onPressedChange={() =>
            props.setIsInEditSiteBoundsMode((prev) => !prev)
          }
          content={
            props.isInEditSiteBoundsMode
              ? 'Stop Editing Site Bounds'
              : 'Edit Site Bounds'
          }
          trigger={
            <StyledMapToggle
              icon={<LocationEditSVG />}
              enabled={props.isInEditSiteBoundsMode}
            />
          }
        />
      </PermissionsGate>
    </Container>
  )
}
